import React from "react";
import { Outlet } from "react-router-dom";

import AuthLayout from "../layouts/AuthLayout";
import Banner from "../components/Banner/Banner";

function Auth() {
  return (
    <AuthLayout leftSection={<Outlet />} rightSection={<Banner />} /> // view component
  );
}

export default Auth;
